// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("/opt/buildhome/repo/static-app/src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-app-tsx": () => import("/opt/buildhome/repo/static-app/src/pages/app.tsx" /* webpackChunkName: "component---src-pages-app-tsx" */),
  "component---src-pages-index-tsx": () => import("/opt/buildhome/repo/static-app/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

